import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#9DA4AB"
      d="M12.163 1.5h2.205L9.55 7.007l5.668 7.493H10.78L7.304 9.955 3.327 14.5H1.12l5.153-5.89L.836 1.5h4.55L8.53 5.654 12.163 1.5Zm-.774 11.68h1.222L4.723 2.75H3.41l7.978 10.43Z"
    />
  </svg>
)
export default SvgComponent
